<template>
  <ProductForm
    v-if="!isProductFetching"
    @saveDetail="saveCustomProduct"
    :productDetail="productDetail"
    :isDefault="isDefault"
    :update="true"
  />
</template>
  
  <script>
import ProductForm from './CustomProductForm.vue';
import { mapActions } from 'vuex';
import OrganizationHelper from '@/mixins/Organization';

export default {
  name: 'EditCustomProduct',
  components: {
    ProductForm,
  },
  data: () => ({
    productDetail: {
      name: '',
      unit: '',
      price: 0,
      sku: null,
      applicableAreas: [],
      treatmentType: {},
      ingredients: '',
      treatmentTiming: '',
      timingOverride: false,
      brandId: '',
      description: '',
      aftercaretemplate: null,
      customApplicableAreas: [],
    },
    isProductFetching: true,
    isDefault: false,
  }),
  mixins: [OrganizationHelper],
  methods: {
    ...mapActions('product', ['fetchProductDetailsV2', 'updateCustomProduct', 'assignCustomTreatmentAreas']),
    async saveCustomProduct(data, selectedTreatmentType, treatmentTypesOption, customTreatmentAreas) {
      try {
        this.$vs.loading();
        const organizationId = localStorage.getItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
        );
        const payload = {
          name: data.name,
          unit: data.unit,
          applicableAreas: data.applicableAreas,
          treatmentType: selectedTreatmentType,
          organizationId,
          ingredients: data.ingredients,
          treatmentTiming: data.treatmentTiming,
          timingOverride: data.timingOverride,
          aftercaretemplate: data.aftercaretemplate,
        };

        await this.assignCustomTreatmentAreas({
          id: data._id,
          payload: {
            organizationId,
            customTreatmentAreas,
            isDefault: this.isDefault,
          },
        });

        /**
         * If product is a fresh product,
         * only update the custom treatment areas
         * and skip updating the whole product
         */
        if (this.isDefault) {
          this.$vs.loading.close();
          this.$router.push({ name: this.getRoleRouteName('CustomProductsList') });
          return;
        }

        delete data.customApplicableAreas;

        const res = await this.updateCustomProduct({
          id: data._id,
          body: payload,
        });
        if (res.status == 200) {
          this.$vs.notify({
            title: 'Product Add',
            text: 'Product Detail added successfully',
            color: 'success',
          });
          this.$vs.loading.close();
          this.$router.push({ name: this.getRoleRouteName('CustomProductsList') });
        }
      } catch (err) {
        this.$vs.notify({
          title: 'Error',
          text: err.data.message,
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    async getProductDetails() {
      try {
        this.$vs.loading();
        const { productId } = this.$route.params;
        const organizationId = localStorage.getItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
        );
        const res = await this.fetchProductDetailsV2({
          id: productId,
          organizationId,
        });
        if (res.status == 200) {
          this.productDetail = res.data.data;
          if (!this.productDetail.customApplicableAreas) this.productDetail.customApplicableAreas = [];
          this.isDefault = this.productDetail.isDefault || false;
        }
        this.isProductFetching = false;
        this.$vs.loading.close();
      } catch (err) {
        this.isProductFetching = false;
        this.$vs.loading.close();
        console.error(err);
      }
    },
  },
  created() {
    this.getProductDetails();
  },
};
</script>
